<template>

  <v-flex>
    <v-checkbox v-model="hasVideos" :label="'Has videos'"></v-checkbox>
  </v-flex>

</template>

<script>

export default {
  name: 'HasVideos',
  props: ['currentValue'],
  data () {
    return {
      hasVideos: false
    }
  },
  mounted () {
    if (this.currentValue) {
      this.hasVideos = this.currentValue
    }
  },
  methods: {
    clear () {
      this.hasVideos = false
    }
  },
  watch: {
    'currentValue' () {
      if (this.currentValue) {
        this.hasVideos = this.currentValue
      }
    },
    'hasVideos' () {
      this.$emit('input', this.hasVideos)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/HasVideos.vue